<script setup lang="ts">
import type { CfgToastNotificationType } from '@cfgtech/ui';
import { CfgToastNotification } from '@cfgtech/ui';
import { Notification, NotificationGroup } from 'notiwind';
import { useEvents } from './composables/events/useEvents';

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | Můj Srovnávač` : 'Můj Srovnávač';
  },
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico?v1.0.1' },
    { rel: 'preload', type: 'image/svg+xml', href: '/sprite.svg' },
  ]
});

// get orders from Bonds
const userState = useUserState();

const { getSyncBondsOrdersState } = useSyncBondsOrders();

watch(userState, (newUserState) => {
  if (newUserState) { getSyncBondsOrdersState(); }
}, { immediate: true });

// rebranding announcement dialog
const route = useRoute();

const showRebrandingAnnouncement = computed(() => 'rebrandingAnnouncement' in route.query);

const { prefetchTotalEvents } = useEvents({}, { lazy: true });

prefetchTotalEvents();
</script>

<template>
  <div class="flex flex-1 flex-col bg-[#fdfdff]">
    <AppOverlay />

    <NuxtLayout>
      <NuxtPage :style="{ flexGrow: 1 }" />
    </NuxtLayout>

    <NotificationGroup group="app">
      <div class="pointer-events-none fixed inset-0 z-toast flex items-start justify-end p-6 px-4">
        <div class="w-full max-w-sm">
          <Notification
            v-slot="{ notifications, close }"
            enter="transform ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-200"
            leave-from="translate-y-0 opacity-100 sm:translate-x-0"
            leave-to="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            move="transition duration-500"
            move-delay="delay-300"
          >
            <div
              v-for="notification in notifications"
              :key="notification.id"
              class="mt-2"
            >
              <CfgToastNotification
                :message="String(notification.text)"
                :title="String(notification.title)"
                :type="(notification.type as CfgToastNotificationType)"
                @close="close(notification.id)"
              />
            </div>
          </Notification>
        </div>
      </div>
    </NotificationGroup>

    <LazyAppRebrandingDialog v-if="showRebrandingAnnouncement" is-opened />

    <AppEvents />
  </div>
</template>

<style>
#__nuxt {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.sprite-container {
  display: none !important;
}

#sentry-feedback {
  width: initial !important;
}
</style>
